import axios from "axios";

const BASE = (process.env.REACT_APP_API_BASE_URL || "http://89.45.89.53:6010")
  .replace(/\/+$/, "");

/**
 * authService — از axios مستقیم استفاده می‌کنه (نه api.js)
 * تا interceptor روی login اجرا نشه
 */
const authService = {

  login: async (phone, password) => {
    console.log("[authService] login payload:", { phone, password: "***" });

    // مستقیم axios — نه api instance — تا interceptor دخالت نکنه
    const { data } = await axios.post(
      `${BASE}/api/users/login/`,
      { phone, password },
      { headers: { "Content-Type": "application/json" } }
    );

    console.log("[authService] login success:", data);
    localStorage.setItem("access_token",  data.access);
    localStorage.setItem("refresh_token", data.refresh);
    return data;
  },

  register: async (payload) => {
    const { data } = await axios.post(
      `${BASE}/api/users/register/`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    localStorage.setItem("access_token",  data.access);
    localStorage.setItem("refresh_token", data.refresh);
    return data;
  },

  getMe: async () => {
    const token = localStorage.getItem("access_token");
    const { data } = await axios.get(
      `${BASE}/api/users/profile/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  },

  updateProfile: async (payload) => {
    const token = localStorage.getItem("access_token");
    const { data } = await axios.patch(
      `${BASE}/api/users/profile/`,
      payload,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );
    return data;
  },

  changePassword: async (oldPassword, newPassword) => {
    const token = localStorage.getItem("access_token");
    const { data } = await axios.post(
      `${BASE}/api/users/change-password/`,
      { old_password: oldPassword, new_password: newPassword, confirm_new_password: newPassword },
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );
    return data;
  },

  refreshToken: async () => {
    const refresh = localStorage.getItem("refresh_token");
    const { data } = await axios.post(
      `${BASE}/api/users/token/refresh/`,
      { refresh },
      { headers: { "Content-Type": "application/json" } }
    );
    localStorage.setItem("access_token", data.access);
    if (data.refresh) localStorage.setItem("refresh_token", data.refresh);
    return data;
  },

  logout: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("cached_user");
  },

  verifyEmail:      async () => ({ success: true }),
  forgotPassword:   async () => ({ success: true }),
  resetPassword:    async () => ({ success: true }),
  submitTalentTest: async () => ({
    detected_skills: [], suggested_tracks: [], message: "آزمون ثبت شد!",
  }),
};

export default authService;